import * as z from "zod/v4";

export const getOriginalImageUrl = {
  name: "getOriginalImageUrl" as const,
  input: z.object({
    imageUrl: z.string().regex(/^https?:\/\/.+/, "Must be a valid URL"),
  }),
  output: z.object({
    originalImageUrl: z.union([
      z.string().regex(/^https?:\/\/.+/, "Must be a valid URL"),
      z.null(),
    ]),
  }),
};
